import { Select, SelectProps } from 'antd';
import { streetsAPI } from 'api/streets';
import { StreetCompact } from 'interfaces/street';
import { memo } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/query-key.enum';

interface Props extends SelectProps<number, StreetCompact> {
  districtId?: number;
}

const SelectStreet = ({ onSelect, districtId, ...props }: Props) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY.GET_STREET_COMPACT_LIST, districtId],
    () => streetsAPI.findAllCompact({ districtId }),
  );

  return (
    <Select
      {...props}
      showSearch
      loading={isLoading}
      options={data?.rows}
      fieldNames={{ label: 'name', value: 'id' }}
      optionFilterProp="name"
    />
  );
};

export default memo(SelectStreet);
